const timeFormatter = new Intl.DateTimeFormat('zh-Hans-CN', {
    timeZone: 'Asia/Shanghai',
    hour12: false,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
});

export function timeToString (timestamp) {
    let dateObj = new Date(timestamp);
    let dateString = timeFormatter.format(dateObj).replace(/\//g, '-');
    return dateString;
}
